import React from "react";

export const CodTransferDetailContext = React.createContext(null);

export const useCodTransferDetailContext = () => {
  const context = React.useContext(CodTransferDetailContext);

  if (!context) throw new Error("COD Transfer Detail Context not provided!");

  return context;
};
